(function () {
    'use strict';

    angular.module('ib-datalayer-ecommerce-module').constant('DatalayerEcommerceConstants', {
        DATALAYER_USER_STATES: {
            'LOGGED': 'logado',
            'ANONYMOUS': 'no_logado'
        },
        DATALAYER_USER_LEVELS: {
            'KIDS': 2,
            'CLASICA': 2,
            'PLATA': 4,
            'ORO': 1,
            'INFINITA': 3,
            'INFINITAPRIME': 3,
            'PLATINO': 3,
            'COLECTIVOS': 'Colectivos',
            'PSEUDOAGENCIA': 'PseudoAgencia',
            'SERVIWEB': 'Serviweb'
        },
        DATALAYER_PASSENGER_TYPES: {
            'ADULT': 'ADT',
            'INFANT': 'INF',
            'YOUNG_ADULT': 'YCD',
            'SENIOR': 'SNR',
            'MINOR': 'MNR',
            'STUDENT': 'STD',
            'CHILD': 'CHD',
            'YOUTH': 'YTH'
        },
        DATALAYER_MODAL_ID: {
            'BACK_MODAL': 'BACK_MODAL',
            'POSIBLE_DELETE_SEGMENT': 'POSIBLE_DELETE_SEGMENT',
            'FARE_CONDITIONS': 'FARE_CONDITIONS',
            'WHERE_IS_PNR': 'WHERE_IS_PNR',
            'PRIVATE_BROWSER_ERROR': 'PRIVATE_BROWSER_ERROR',
            'CANCEL_SPECIAL_NEEDS_CONFIRMATION': 'CANCEL_SPECIAL_NEEDS_CONFIRMATION',
            'ADVICE_PA_BOOKING': 'ADVICE_PA_BOOKING',
            'INFO_CONFIDENTIALITY': 'INFO_CONFIDENTIALITY',
            'CHECKIN_ONLINE_MORE_INFO': 'CHECKIN_ONLINE_MORE_INFO',
            'BAGGAGE_POLICY': 'BAGGAGE_POLICY',
            'BAGGAGE_WARNING': 'BAGGAGE_WARNING',
            'SEGMENT_BAGGAGE_SUMMARY': 'SEGMENT_BAGGAGE_SUMMARY',
            'BOARDING_CARD_AT_LEAST_ONE_SEND_TYPE_WARNING': 'BOARDING_CARD_AT_LEAST_ONE_SEND_TYPE_WARNING',
            'BOARDING_CARD_AT_LEAST_ONE_FORMAT_WARNING': 'BOARDING_CARD_AT_LEAST_ONE_FORMAT_WARNING',
            'BOARDING_CARD_FINISH_CHECKIN': 'BOARDING_CARD_FINISH_CHECKIN',
            'BAGGAGE_RESTRICTIONS': 'BAGGAGE_RESTRICTIONS',
            'ACCEPT_FORBIDDEN_ITEMS': 'ACCEPT_FORBIDDEN_ITEMS',
            'AT_LEAST_ONE_PASSENGER_WARNING': 'AT_LEAST_ONE_PASSENGER_WARNING',
            'EXCEDED_TOTAL_PASSENGER_WARNING': 'EXCEDED_TOTAL_PASSENGER_WARNING',
            'NO_PREVIOUS_SEGMENT_WARNING': 'NO_PREVIOUS_SEGMENT_WARNING',
            'SEGMENT_IN_GROUP_WARNING': 'SEGMENT_IN_GROUP_WARNING',
            'PAYMENTS_TERMS_AND_CONTRACT_CONDITIONS': 'PAYMENTS_TERMS_AND_CONTRACT_CONDITIONS',
            'PAYMENTS_CVV': 'PAYMENTS_CVV',
            'BOOKING_SPLIT': 'BOOKING_SPLIT',
            'PENDING_PEYMENTS': 'PENDING_PEYMENTS'
        },
        DATALAYER_INFO: {
            'LANGUAGE': 'idioma',
            'MARKET': 'mercado',
            'USER_STATE': 'EstadoUsuario',
            'QUADRIGAM': 'quadrigam',
            'CODE': 'codigoSeguimiento',
            'WEB_VERSION': 'versionWeb',
            'WEB_MODE': 'modeWeb',
            'USER_LEVEL': 'NivelUsuario',
            'USER_ID': 'userID',
            'USER_SEGMENT': 'segmento',
            'IS_AIR_SHUTTLE': 'puenteAereo',
            'ORIGIN_DESTINATIONS': 'trayectoAeropuerto',
            'PASSENGER_TYPES': 'tipoPax',
            'TOTAL_PASSENGERS': 'numeroPax',
            'SEGMENT_OPERATORS': 'operadoraVuelo',
            'SEGMENT_DATES': 'fecha',
            'DEPARTURE_AIRPORT': 'aeropuertoOrigen',
            'ARRIVAL_AIRPORT': 'aeropuertoDestino',
            'TOTAL_AVAILABILITY': 'resultadosBusqueda',
            'DEPARTURE_TIME': 'horarioSalida',
            'ERROR_CODE': 'errorSeverityCode',
            'ERROR_DESCRIPTION': 'tipoError',
            'MODAL_ID': 'modal',
            'INIT_TYPE': 'detalleInicio',
            'ANCILLARIES_BOUGHT': 'ancillariesComprados',
            'BOOKING_CLASS': 'claseReserva',
            'UPGRADE_SHOWN': 'upgradingMostrado',
            'UPGRADE_SENT': 'upgradingEnviado',
            'UPGRADE_TOTAL': 'upgradingImporteMoneda',
            'APIS_FULFILLED': 'APIScumplimentados',
            'HPBT': 'HPBT',
            'DOWNLOAD_FORMAT': 'formatoDescarga',
            'VIP_ROOM': 'salaVIP'
        },
        DATALAYER_VOLUNTARYCHANGES: {
            'PRICE_PASSANGER': 'precioPax',
            'STOPOVER_FLIGHT': 'escalas',
            'BOOKING_CLASS': 'claseReserva',
            'FLIGHT_TIME': 'horarioVuelo',
            'FARE_NAMES': 'nombreTarifas',
            'SEGMENT_OPERATORS': 'operadoraVuelo',
            'TOTAL_PRICE': 'precioTotal',
            'TOTAL_PRICE_WITHOUT_TAX': 'precioTotalSinTasas',
            'CHEAP_FARE': 'tarifaBarata',
            'IDENTIFIER': 'Identifier',
            'CABINES': 'cabinas',
            'COIN': 'moneda',
            'IBERIAPLUS_HOLDER': 'titularIberiaPlus',
            'ORIGIN_DESTINATIONS': 'trayectoAeropuerto',
            'SEARCHED_PATH': 'trayectoBuscado',
            'COUNTRY_PATH': 'trayectoPais',
        },
        DATALAYER_EVENT_TYPES: {
            'VIEW': 'view',
            'LINK': 'link'
        },
        DATALAYER_ECOMMERCE: {
            'CURRENCY': 'currency',
            'TRANSACTION': 'transaction',
            'TRANSACTION_ID': 'id',
            'TRANSACTION_AFFIL': 'affiliation',
            'TRANSACTION_TAX': 'tax',
            'PRODUCTS': 'products',
            'PRODUCTS_NAME': 'name',
            'PRODUCTS_ID': 'id',
            'PRODUCTS_CATEGORY': 'category',
            'PRODUCTS_QUANTITY': 'quantity',
            'PRODUCTS_PRICE': 'price',
            'REVENUE': 'revenue',
            'SHIPPING': 'shipping',
            'TYPE_FLIGHT': 'flight',
            'TYPE_SNEEDS': 'specialNeed',
            'TOTAL_PRICE': 'precioTotal',
            'TOTAL_PRICE_WITHOUT_TAX': 'precioTotalSinTasas',
            'DONATION_ITEM_TYPE': 'donation',
            'ITEM_VALID': 'OK'
        },
        DATALAYER_VALUES: {
            'YES': 'SI',
            'NO': 'NO',
            'WEB_VERSION': 'angularjs',
            'INIT_LOCATOR': 'por localizador',
            'INIT_IB_PLUS': 'por IB plus',
            'FREE': 'gratuito',
            'PAYMENT': 'pago',
            'BAGGAGES': 'Maletas',
            'SEATS': 'Asientos',
            'ASSURANCES': 'Seguros',
            'PDF_FORMAT': 'PDF',
            'QR_FORMAT': 'QR',
            'PASSBOOK_FORMAT': 'Passbook',
            'OFFERED': 'Ofertados',
            'EMITED': 'Emitidos',
            'SEGMENT_OPEN': 'OPEN',
            ORDER_KEYS: {
                'TIME_ASC': 'Horario Ascendente',
                'TIME_DESC': 'Horario Descendente',
                'DURATION_ASC': 'Duración Ascendente',
                'DURATION_DESC': 'Duración Descendente',
                'CABINS_AND_PRICE_ASC': 'Cabinas y precios Ascendente',
                'CABINS_AND_PRICE_DESC': 'Cabinas y precios Descendente'
            },
            'ORDER_EVENT_OUTBOUND': 'ordenarIdaPor',
            'ORDER_EVENT_INBOUND': 'ordenarVueltaPor',
            'ANCILLARIES_EVENT': 'addAncillaries',
            'ONE_WAY_TRIP': 'OW',
            'RETURN_TRIP': 'RT',
            'MULTIPLE_TRIP': 'MT',
            'FARE_FAMILY_STANDARD': 'STANDARD',
            'CABIN_FAMILY_STANDARD': 'STANDARD',
            PASSENGERS_TYPES: {
                'ADULT': 'ADT',
                'CHILD': 'CHD',
                'INFANT': 'INF',
                'SENIOR': 'YCD',
                'YOUTH': 'YTH',
                'YOUNG_ADULT': 'BNN'
            },
            'RED_MOBILITY_PAX': 'paxMovilidadReducida',
            'LARGE_FAMILY': 'familiaNumerosaTipo',
            'RESIDENT': 'residente',
            'ORDER_ID': 'OrderId',
            SPECIAL_DISCOUNTS: {
                'RESIDENT': 'RES',
                'SPECIAL': 'SPECIAL',
                'LARGE_FAMILY': 'LGF',
                'LARGE_FAMILY_SPECIAL': 'F2',
                'LARGE_FAMILY_NORMAL': 'F1'
            },
            PAYMENT_METHODS: {
                'VOUCHER': 'fullVoucher',
                'CASH_AVIOS': 'cash&Avios',
                'CASH_VOUCHER': 'cash&Voucher',
                'CASH': 'cash'
            },
            PURCHASE_CATEGORY: {
                'DIRECT': 'compra directa',
                'REDEMPTION': 'Redención',
                'ON_HOLD': 'Reserva On-Hold',
                'ON_HOLD_CONFIRMATION': 'Confirmación On-Hold',
                'CHECK_IN': 'checkin',
                'MMBANC': 'Gestión de reservas'
            }
        },
        SEGMENT_TYPES: {
            'OPEN': 'OPEN',
            'CONFIRMED': 'CONFIRMED',
        },
        PASSENGERS_TYPES: {
            'ADULT': 'ADULT',
            'CHILD': 'CHILD',
            'INFANT': 'INFANT'
        },
        SEGMENT_CABIN_PRIORITY: {
            'F': 1,
            'B': 2,
            'E': 3,
            'R': 4
        },
        SPECIAL_NEEDS_CODE: {
            'BLIND': 'BLND',
            'DEAF': 'DEAF',
            'SVAN': 'SVAN'
        }
    });
})();
